import { render, staticRenderFns } from "./BarcodeItemSelector.vue?vue&type=template&id=40458bb4&"
import script from "./BarcodeItemSelector.vue?vue&type=script&lang=ts&"
export * from "./BarcodeItemSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports